// // src/components/EventForm/DescriptionSection.js
// import React from 'react';
// import styled from 'styled-components';
// import Typography from '../../components/Typography';
// import InputTextArea from '../../components/Input/InputTextArea';
// import { theme } from '../../theme';
// import { useTranslation } from 'react-i18next';

// const DescriptionSection = ({ description, onChange, error }) => {
//   const { t } = useTranslation('createEvent');
//   return (
//     <Wrapper>
//       <Typography as="label" $variant="body-1-semibold" color={theme.colors.defaultStrong}>
//         {t('eventForm.details')}
//       </Typography>
//       <InputWrapper>
//         <DescriptionArea
//           size="large"
//           name="description"
//           value={description}
//           onChange={onChange}
//           placeholder={t('eventForm.detailsPlaceholder')}
//           $variant={error ? 'error' : ''}
//           required
//         />
//         {error &&
//           <Typography as="p" $variant="body-2-medium" color={theme.colors.errorMain}>
//             {error}
//           </Typography>
//         }
//       </InputWrapper>
//     </Wrapper>
//   );
// };

// export default DescriptionSection;

// const Wrapper = styled.div`
//   gap: ${({ theme }) => theme.sizing.xs};
//   width: 100%;
//   display: flex;
//   flex-direction: column;
// `;

// const InputWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: ${({ theme }) => theme.sizing.xxs};
//   flex-grow: 1;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
// `;

// const DescriptionArea = styled(InputTextArea)`
//   field-sizing: content;
//   min-height: 80px;
// `;


// src/components/EventForm/DescriptionSection.js
import React, { useState } from 'react';
import styled from 'styled-components';
import Typography from '../../components/Typography';
import { theme } from '../../theme';
import { useTranslation } from 'react-i18next';
import CreateEventDescriptionModal from '../Modal/CreateEventDescriptionModal';

const DescriptionSection = ({ description, onChange, error }) => {
  const { t } = useTranslation('createEvent');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <Description>
      <Wrapper>
        <HeaderWrapper>
          <Typography as="label" $variant="body-1-semibold" color={theme.colors.defaultStrong}>
            {t('createEventDescriptionModal.description')}
          </Typography>
        </HeaderWrapper>
        <DescriptionPreview onClick={handleOpenModal}>
          {description ? (
            <UserDescription as="p" $variant="body-1-regular" color={theme.colors.defaultMain}>
              {description}
            </UserDescription>
          ) : (
            <Typography as="p" $variant="body-1-regular" color={theme.colors.defaultWeak}>
              {t('createEventDescriptionModal.descriptionPlaceholder')}
            </Typography>
          )}
        </DescriptionPreview>
      </Wrapper>

      {error && (
        <ErrorMessage>
          <Typography as="p" $variant="body-2-medium" color={theme.colors.errorMain}>
            {error}
          </Typography>
        </ErrorMessage>
      )}

      {isModalOpen && (
        <CreateEventDescriptionModal
          description={description}
          onChange={onChange}
          error={error}
          onClose={handleCloseModal}
        />
      )}
    </Description>
  );
};

export default DescriptionSection;

const Description = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  padding-top: ${({ theme }) => theme.sizing.sm};
  padding-bottom: ${({ theme }) => theme.sizing.sm};
  width: 100%;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    border-top: 1px solid ${({ theme }) => theme.border.defaultSubtle};
    margin-top: ${({ theme }) => theme.sizing.md};
  }
`;

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const DescriptionPreview = styled.div`
  background-color: ${({ theme }) => theme.fill.defaultSubtle};
  border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  border-radius: ${({ theme }) => theme.radius.xs};
  cursor: pointer;
  min-height: 80px;
  padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.sm};
  transition: background-color 0.3s ease-in-out;
  
  &:hover {
    background-color: ${({ theme }) => theme.fill.defaultWeak};
  }
`;

const UserDescription = styled(Typography)`
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3; 
  line-height: 1.5em;
  max-height: 4.5em;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ErrorMessage = styled.div`
  display: flex;
  padding-top: ${({ theme }) => theme.sizing.xs};
`;